import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  head: {
    color: theme.custom.color.blackRussian,
    fontSize: 16,
    letterSpacing: 0,
    textAlign: "start",
    marginBottom: theme.spacing(3),
  },
  selectItem: {
    height: "56px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    color: theme.custom.color.pewter,
    border: theme.custom.border.secondary,
    borderRadius: "4px",
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.8, 2),
    boxSizing: "border-box",
  },
  active: {
    border: theme.custom.border.active,
    color: theme.custom.color.black,
    fontWeight: "bold",
  },
  icon: {
    width: "24px",
    height: "24px",
  },
  label: {
    fontSize: "16px",
    letterSpacing: 0.1,
    lineHeight: "22px",
    marginLeft: theme.spacing(2.25),
  },
  left: {
    display: "flex",
    flexDirection: "row",
  },
  right: {
    display: "flex",
    flexDirection: "row",
  },
  checkIcon: {
    color: theme.custom.color.summersky,
  },
}));
